<script setup lang="ts">
    import CommentsMessages from '@/components/company-comments/CommentsMessages.vue';
    import CommentsInput from '@/components/company-comments/CommentsInput.vue';
    import type { Company, DashboardTableData } from '@/types';
    import {
        Dialog,
        DialogBody,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogTrigger,
    } from '@/components/ui/dialog';
    import { Button } from '@/components/ui/button';
    import { computed, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import Chat from '@/components/icons/Chat.vue';

    const { t } = useI18n();

    const props = defineProps<{
        company: DashboardTableData;
        commentCount: number;
    }>();

    const commentCountRef = ref<number>(props.commentCount);

    const commentCountFormatted = computed(() => {
        return commentCountRef.value > 9 ? '9+' : commentCountRef.value;
    });
</script>

<template>
    <Dialog>
        <DialogTrigger class="relative flex cursor-pointer items-center justify-center">
            <Chat className="text-primary size-4 shrink-0" />
            <span
                v-if="commentCountRef > 0"
                class="bg-secondary absolute -top-1 -right-1 flex h-3 w-3 items-center justify-center rounded-full text-[8px] font-bold text-white"
                :class="{
                    '-right-1.5 w-fit px-1': commentCountRef > 9,
                }"
            >
                {{ commentCountFormatted }}
            </span>
        </DialogTrigger>
        <DialogContent class="sm:max-w-lg">
            <DialogHeader>
                <DialogTitle>
                    {{ t('dashboards.comment.title', { company: company.name }) }}
                </DialogTitle>
            </DialogHeader>

            <DialogBody>
                <CommentsMessages
                    :company-id="company.id"
                    :comment-count="commentCountRef"
                />
                <CommentsInput
                    :company-id="company.id"
                    :status-id="company.status_id"
                    @comment-added="commentCountRef++"
                />
            </DialogBody>
        </DialogContent>
    </Dialog>
</template>
